import { FormLabel } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export default function Label({ 
  htmlForValue = '',
  label,
  style = {},
  useGctrad = false
}) {

  const {t: gctrad} = useTranslation();

  return (
    <FormLabel 
      className="text-gc-dark-blue font-weight-normal m-0 mb-1" 
      htmlFor={htmlForValue} 
      style={{fontSize: '.9rem', ...style}}
    >
      {capitalize(useGctrad ? gctrad(label) : label.trad())}
    </FormLabel>
  );
}